// THIS FILE IS AUTO-GENERATED.
// Source: https://chromium-i18n.appspot.com/ssl-address
// Generated by: scripts/generate_country_rules.ts
// Do not edit by hand.

export type LibAddressInputRule = {
  require?: string;
  zip?: string;
  zipex?: string;
  zip_name_type?: string;
  state_name_type?: string;
};

export const COUNTRY_RULES: Record<string, LibAddressInputRule> = {
  "AD": {
    "zip": "AD[1-7]0\\d",
    "zipex": "AD100,AD501,AD700"
  },
  "AE": {
    "require": "AS",
    "state_name_type": "emirate"
  },
  "AF": {
    "zip": "\\d{4}",
    "zipex": "1001,2601,3801"
  },
  "AG": {
    "require": "A"
  },
  "AI": {
    "zip": "(?:AI-)?2640",
    "zipex": "2640"
  },
  "AL": {
    "zip": "\\d{4}",
    "zipex": "1001,1017,3501"
  },
  "AM": {
    "zip": "(?:37)?\\d{4}",
    "zipex": "375010,0002,0010"
  },
  "AO": {},
  "AQ": {},
  "AR": {
    "zip": "((?:[A-HJ-NP-Z])?\\d{4})([A-Z]{3})?",
    "zipex": "C1070AAM,C1000WAM,B1000TBU,X5187XAB"
  },
  "AS": {
    "require": "ACSZ",
    "zip": "(96799)(?:[ \\-](\\d{4}))?",
    "zipex": "96799",
    "zip_name_type": "zip",
    "state_name_type": "state"
  },
  "AT": {
    "require": "ACZ",
    "zip": "\\d{4}",
    "zipex": "1010,3741"
  },
  "AU": {
    "require": "ACSZ",
    "zip": "\\d{4}",
    "zipex": "2060,3171,6430,4000,4006,3001",
    "state_name_type": "state"
  },
  "AW": {},
  "AX": {
    "require": "ACZ",
    "zip": "22\\d{3}",
    "zipex": "22150,22550,22240,22710,22270,22730,22430"
  },
  "AZ": {
    "zip": "\\d{4}",
    "zipex": "1000"
  },
  "BA": {
    "zip": "\\d{5}",
    "zipex": "71000"
  },
  "BB": {
    "zip": "BB\\d{5}",
    "zipex": "BB23026,BB22025",
    "state_name_type": "parish"
  },
  "BD": {
    "zip": "\\d{4}",
    "zipex": "1340,1000"
  },
  "BE": {
    "require": "ACZ",
    "zip": "\\d{4}",
    "zipex": "4000,1000"
  },
  "BF": {},
  "BG": {
    "zip": "\\d{4}",
    "zipex": "1000,1700"
  },
  "BH": {
    "zip": "(?:^|\\b)(?:1[0-2]|[1-9])\\d{2}(?:$|\\b)",
    "zipex": "317"
  },
  "BI": {},
  "BJ": {},
  "BL": {
    "require": "ACZ",
    "zip": "9[78][01]\\d{2}",
    "zipex": "97100"
  },
  "BM": {
    "zip": "[A-Z]{2} ?[A-Z0-9]{2}",
    "zipex": "FL 07,HM GX,HM 12"
  },
  "BN": {
    "zip": "[A-Z]{2} ?\\d{4}",
    "zipex": "BT2328,KA1131,BA1511"
  },
  "BO": {},
  "BQ": {},
  "BR": {
    "require": "ASCZ",
    "zip": "\\d{5}-?\\d{3}",
    "zipex": "40301-110,70002-900",
    "state_name_type": "state"
  },
  "BS": {
    "state_name_type": "island"
  },
  "BT": {
    "zip": "\\d{5}",
    "zipex": "11001,31101,35003"
  },
  "BV": {},
  "BW": {},
  "BY": {
    "zip": "\\d{6}",
    "zipex": "223016,225860,220050"
  },
  "BZ": {},
  "CA": {
    "require": "ACSZ",
    "zip": "[ABCEGHJKLMNPRSTVXY]\\d[ABCEGHJ-NPRSTV-Z] ?\\d[ABCEGHJ-NPRSTV-Z]\\d",
    "zipex": "H3Z 2Y7,V8X 3X4,T0L 1K0,T0H 1A0,K1A 0B1"
  },
  "CC": {
    "zip": "6799",
    "zipex": "6799"
  },
  "CD": {},
  "CF": {},
  "CG": {},
  "CH": {
    "require": "ACZ",
    "zip": "\\d{4}",
    "zipex": "2544,1211,1556,3030"
  },
  "CI": {},
  "CK": {},
  "CL": {
    "zip": "\\d{7}",
    "zipex": "8340457,8720019,1230000,8329100"
  },
  "CM": {},
  "CN": {
    "require": "ACSZ",
    "zip": "\\d{6}",
    "zipex": "266033,317204,100096,100808"
  },
  "CO": {
    "require": "AS",
    "zip": "\\d{6}",
    "zipex": "111221,130001,760011",
    "state_name_type": "department"
  },
  "CR": {
    "require": "ACS",
    "zip": "\\d{4,5}|\\d{3}-\\d{4}",
    "zipex": "1000,2010,1001"
  },
  "CU": {
    "zip": "\\d{5}",
    "zipex": "10700"
  },
  "CV": {
    "zip": "\\d{4}",
    "zipex": "7600",
    "state_name_type": "island"
  },
  "CW": {},
  "CX": {
    "zip": "6798",
    "zipex": "6798"
  },
  "CY": {
    "zip": "\\d{4}",
    "zipex": "2008,3304,1900"
  },
  "CZ": {
    "require": "ACZ",
    "zip": "\\d{3} ?\\d{2}",
    "zipex": "100 00,251 66,530 87,110 00,225 99"
  },
  "DE": {
    "require": "ACZ",
    "zip": "\\d{5}",
    "zipex": "26133,53225"
  },
  "DJ": {},
  "DK": {
    "require": "ACZ",
    "zip": "\\d{4}",
    "zipex": "8660,1566"
  },
  "DM": {},
  "DO": {
    "zip": "\\d{5}",
    "zipex": "11903,10101"
  },
  "DZ": {
    "zip": "\\d{5}",
    "zipex": "40304,16027"
  },
  "EC": {
    "zip": "\\d{6}",
    "zipex": "090105,092301"
  },
  "EE": {
    "require": "ACZ",
    "zip": "\\d{5}",
    "zipex": "69501,11212"
  },
  "EG": {
    "zip": "\\d{5}",
    "zipex": "12411,11599"
  },
  "EH": {
    "zip": "\\d{5}",
    "zipex": "70000,72000"
  },
  "ER": {},
  "ES": {
    "require": "ACSZ",
    "zip": "\\d{5}",
    "zipex": "28039,28300,28070"
  },
  "ET": {
    "zip": "\\d{4}",
    "zipex": "1000"
  },
  "FI": {
    "require": "ACZ",
    "zip": "\\d{5}",
    "zipex": "00550,00011"
  },
  "FJ": {},
  "FK": {
    "require": "ACZ",
    "zip": "FIQQ 1ZZ",
    "zipex": "FIQQ 1ZZ"
  },
  "FM": {
    "require": "ACSZ",
    "zip": "(9694[1-4])(?:[ \\-](\\d{4}))?",
    "zipex": "96941,96944",
    "zip_name_type": "zip",
    "state_name_type": "state"
  },
  "FO": {
    "zip": "\\d{3}",
    "zipex": "100"
  },
  "FR": {
    "require": "ACZ",
    "zip": "\\d{2} ?\\d{3}",
    "zipex": "33380,34092,33506"
  },
  "GA": {},
  "GB": {
    "require": "ACZ",
    "zip": "GIR ?0AA|(?:(?:AB|AL|B|BA|BB|BD|BF|BH|BL|BN|BR|BS|BT|BX|CA|CB|CF|CH|CM|CO|CR|CT|CV|CW|DA|DD|DE|DG|DH|DL|DN|DT|DY|E|EC|EH|EN|EX|FK|FY|G|GL|GY|GU|HA|HD|HG|HP|HR|HS|HU|HX|IG|IM|IP|IV|JE|KA|KT|KW|KY|L|LA|LD|LE|LL|LN|LS|LU|M|ME|MK|ML|N|NE|NG|NN|NP|NR|NW|OL|OX|PA|PE|PH|PL|PO|PR|RG|RH|RM|S|SA|SE|SG|SK|SL|SM|SN|SO|SP|SR|SS|ST|SW|SY|TA|TD|TF|TN|TQ|TR|TS|TW|UB|W|WA|WC|WD|WF|WN|WR|WS|WV|YO|ZE)(?:\\d[\\dA-Z]? ?\\d[ABD-HJLN-UW-Z]{2}))|BFPO ?\\d{1,4}",
    "zipex": "EC1Y 8SY,GIR 0AA,M2 5BQ,M34 4AB,CR0 2YR,DN16 9AA,W1A 4ZZ,EC1A 1HQ,OX14 4PG,BS18 8HF,NR25 7HG,RH6 0NP,BH23 6AA,B6 5BA,SO23 9AP,PO1 3AX,BFPO 61"
  },
  "GD": {},
  "GE": {
    "zip": "\\d{4}",
    "zipex": "0101"
  },
  "GF": {
    "require": "ACZ",
    "zip": "9[78]3\\d{2}",
    "zipex": "97300"
  },
  "GG": {
    "require": "ACZ",
    "zip": "GY\\d[\\dA-Z]? ?\\d[ABD-HJLN-UW-Z]{2}",
    "zipex": "GY1 1AA,GY2 2BT"
  },
  "GH": {},
  "GI": {
    "require": "A",
    "zip": "GX11 1AA",
    "zipex": "GX11 1AA"
  },
  "GL": {
    "require": "ACZ",
    "zip": "39\\d{2}",
    "zipex": "3900,3950,3911"
  },
  "GM": {},
  "GN": {
    "zip": "\\d{3}",
    "zipex": "001,200,100"
  },
  "GP": {
    "require": "ACZ",
    "zip": "9[78][01]\\d{2}",
    "zipex": "97100"
  },
  "GQ": {},
  "GR": {
    "require": "ACZ",
    "zip": "\\d{3} ?\\d{2}",
    "zipex": "151 24,151 10,101 88"
  },
  "GS": {
    "require": "ACZ",
    "zip": "SIQQ 1ZZ",
    "zipex": "SIQQ 1ZZ"
  },
  "GT": {
    "zip": "\\d{5}",
    "zipex": "09001,01501"
  },
  "GU": {
    "require": "ACZ",
    "zip": "(969(?:[12]\\d|3[12]))(?:[ \\-](\\d{4}))?",
    "zipex": "96910,96931",
    "zip_name_type": "zip"
  },
  "GW": {
    "zip": "\\d{4}",
    "zipex": "1000,1011"
  },
  "GY": {},
  "HK": {
    "require": "AS",
    "state_name_type": "area"
  },
  "HM": {
    "zip": "\\d{4}",
    "zipex": "7050"
  },
  "HN": {
    "require": "ACS",
    "zip": "\\d{5}",
    "zipex": "31301",
    "state_name_type": "department"
  },
  "HR": {
    "zip": "\\d{5}",
    "zipex": "10000,21001,10002"
  },
  "HT": {
    "zip": "\\d{4}",
    "zipex": "6120,5310,6110,8510"
  },
  "HU": {
    "require": "ACZ",
    "zip": "\\d{4}",
    "zipex": "1037,2380,1540"
  },
  "ID": {
    "require": "AS",
    "zip": "\\d{5}",
    "zipex": "40115"
  },
  "IE": {
    "zip": "[\\dA-Z]{3} ?[\\dA-Z]{4}",
    "zipex": "A65 F4E2",
    "zip_name_type": "eircode",
    "state_name_type": "county"
  },
  "IL": {
    "zip": "\\d{5}(?:\\d{2})?",
    "zipex": "9614303"
  },
  "IM": {
    "require": "ACZ",
    "zip": "IM\\d[\\dA-Z]? ?\\d[ABD-HJLN-UW-Z]{2}",
    "zipex": "IM2 1AA,IM99 1PS"
  },
  "IN": {
    "require": "ACSZ",
    "zip": "\\d{6}",
    "zipex": "110034,110001",
    "zip_name_type": "pin",
    "state_name_type": "state"
  },
  "IO": {
    "require": "ACZ",
    "zip": "BBND 1ZZ",
    "zipex": "BBND 1ZZ"
  },
  "IQ": {
    "require": "ACS",
    "zip": "\\d{5}",
    "zipex": "31001"
  },
  "IR": {
    "zip": "\\d{5}-?\\d{5}",
    "zipex": "11936-12345"
  },
  "IS": {
    "zip": "\\d{3}",
    "zipex": "320,121,220,110"
  },
  "IT": {
    "require": "ACSZ",
    "zip": "\\d{5}",
    "zipex": "00144,47037,39049"
  },
  "JE": {
    "require": "ACZ",
    "zip": "JE\\d[\\dA-Z]? ?\\d[ABD-HJLN-UW-Z]{2}",
    "zipex": "JE1 1AA,JE2 2BT"
  },
  "JM": {
    "require": "ACS",
    "state_name_type": "parish"
  },
  "JO": {
    "zip": "\\d{5}",
    "zipex": "11937,11190"
  },
  "JP": {
    "require": "ASZ",
    "zip": "\\d{3}-?\\d{4}",
    "zipex": "154-0023,350-1106,951-8073,112-0001,208-0032,231-0012",
    "state_name_type": "prefecture"
  },
  "KE": {
    "zip": "\\d{5}",
    "zipex": "20100,00100"
  },
  "KG": {
    "zip": "\\d{6}",
    "zipex": "720001"
  },
  "KH": {
    "zip": "\\d{5,6}",
    "zipex": "120101,120108"
  },
  "KI": {
    "state_name_type": "island"
  },
  "KM": {},
  "KN": {
    "require": "ACS",
    "state_name_type": "island"
  },
  "KP": {},
  "KR": {
    "require": "ACSZ",
    "zip": "\\d{5}",
    "zipex": "03051",
    "state_name_type": "do_si"
  },
  "KW": {
    "zip": "\\d{5}",
    "zipex": "54541,54551,54404,13009"
  },
  "KY": {
    "require": "AS",
    "zip": "KY\\d-\\d{4}",
    "zipex": "KY1-1100,KY1-1702,KY2-2101",
    "state_name_type": "island"
  },
  "KZ": {
    "zip": "\\d{6}",
    "zipex": "040900,050012"
  },
  "LA": {
    "zip": "\\d{5}",
    "zipex": "01160,01000"
  },
  "LB": {
    "zip": "(?:\\d{4})(?: ?(?:\\d{4}))?",
    "zipex": "2038 3054,1107 2810,1000"
  },
  "LC": {},
  "LI": {
    "require": "ACZ",
    "zip": "948[5-9]|949[0-8]",
    "zipex": "9496,9491,9490,9485"
  },
  "LK": {
    "zip": "\\d{5}",
    "zipex": "20000,00100"
  },
  "LR": {
    "zip": "\\d{4}",
    "zipex": "1000"
  },
  "LS": {
    "zip": "\\d{3}",
    "zipex": "100"
  },
  "LT": {
    "require": "ACZ",
    "zip": "\\d{5}",
    "zipex": "04340,03500"
  },
  "LU": {
    "require": "ACZ",
    "zip": "\\d{4}",
    "zipex": "4750,2998"
  },
  "LV": {
    "require": "ACZ",
    "zip": "(?:LV-)?\\d{4}",
    "zipex": "LV-1073,LV-1000"
  },
  "LY": {},
  "MA": {
    "zip": "\\d{5}",
    "zipex": "53000,10000,20050,16052"
  },
  "MC": {
    "zip": "980\\d{2}",
    "zipex": "98000,98020,98011,98001"
  },
  "MD": {
    "zip": "\\d{4}",
    "zipex": "2012,2019"
  },
  "ME": {
    "zip": "8\\d{4}",
    "zipex": "81257,81258,81217,84314,85366"
  },
  "MF": {
    "require": "ACZ",
    "zip": "9[78][01]\\d{2}",
    "zipex": "97100"
  },
  "MG": {
    "zip": "\\d{3}",
    "zipex": "501,101"
  },
  "MH": {
    "require": "ACSZ",
    "zip": "(969[67]\\d)(?:[ \\-](\\d{4}))?",
    "zipex": "96960,96970",
    "zip_name_type": "zip",
    "state_name_type": "state"
  },
  "MK": {
    "zip": "\\d{4}",
    "zipex": "1314,1321,1443,1062"
  },
  "ML": {},
  "MM": {
    "zip": "\\d{5}",
    "zipex": "11181"
  },
  "MN": {
    "zip": "\\d{5}",
    "zipex": "65030,65270"
  },
  "MO": {
    "require": "A"
  },
  "MP": {
    "require": "ACSZ",
    "zip": "(9695[012])(?:[ \\-](\\d{4}))?",
    "zipex": "96950,96951,96952",
    "zip_name_type": "zip",
    "state_name_type": "state"
  },
  "MQ": {
    "require": "ACZ",
    "zip": "9[78]2\\d{2}",
    "zipex": "97220"
  },
  "MR": {},
  "MS": {},
  "MT": {
    "zip": "[A-Z]{3} ?\\d{2,4}",
    "zipex": "NXR 01,ZTN 05,GPO 01,BZN 1130,SPB 6031,VCT 1753"
  },
  "MU": {
    "zip": "\\d{3}(?:\\d{2}|[A-Z]{2}\\d{3})",
    "zipex": "42602"
  },
  "MV": {
    "zip": "\\d{5}",
    "zipex": "20026"
  },
  "MW": {},
  "MX": {
    "require": "ACSZ",
    "zip": "\\d{5}",
    "zipex": "02860,77520,06082",
    "state_name_type": "state"
  },
  "MY": {
    "require": "ACZ",
    "zip": "\\d{5}",
    "zipex": "43000,50754,88990,50670",
    "state_name_type": "state"
  },
  "MZ": {
    "zip": "\\d{4}",
    "zipex": "1102,1119,3212"
  },
  "NA": {
    "zip": "\\d{5}",
    "zipex": "10001,10017"
  },
  "NC": {
    "require": "ACZ",
    "zip": "988\\d{2}",
    "zipex": "98814,98800,98810"
  },
  "NE": {
    "zip": "\\d{4}",
    "zipex": "8001"
  },
  "NF": {
    "zip": "2899",
    "zipex": "2899"
  },
  "NG": {
    "zip": "\\d{6}",
    "zipex": "930283,300001,931104",
    "state_name_type": "state"
  },
  "NI": {
    "zip": "\\d{5}",
    "zipex": "52000",
    "state_name_type": "department"
  },
  "NL": {
    "require": "ACZ",
    "zip": "[1-9]\\d{3} ?(?:[A-RT-Z][A-Z]|S[BCE-RT-Z])",
    "zipex": "1234 AB,2490 AA"
  },
  "NO": {
    "require": "ACZ",
    "zip": "\\d{4}",
    "zipex": "0025,0107,6631"
  },
  "NP": {
    "zip": "\\d{5}",
    "zipex": "44601"
  },
  "NR": {
    "require": "AS",
    "state_name_type": "district"
  },
  "NU": {},
  "NZ": {
    "require": "ACZ",
    "zip": "\\d{4}",
    "zipex": "6001,6015,6332,8252,1030"
  },
  "OM": {
    "zip": "(?:PC )?\\d{3}",
    "zipex": "133,112,111"
  },
  "PA": {},
  "PE": {
    "zip": "(?:LIMA \\d{1,2}|CALLAO 0?\\d)|[0-2]\\d{4}",
    "zipex": "LIMA 23,LIMA 42,CALLAO 2,02001"
  },
  "PF": {
    "require": "ACSZ",
    "zip": "987\\d{2}",
    "zipex": "98709",
    "state_name_type": "island"
  },
  "PG": {
    "require": "ACS",
    "zip": "\\d{3}",
    "zipex": "111"
  },
  "PH": {
    "zip": "\\d{4}",
    "zipex": "1008,1050,1135,1207,2000,1000"
  },
  "PK": {
    "zip": "\\d{5}",
    "zipex": "44000"
  },
  "PL": {
    "require": "ACZ",
    "zip": "\\d{2}-\\d{3}",
    "zipex": "00-950,05-470,48-300,32-015,00-940"
  },
  "PM": {
    "require": "ACZ",
    "zip": "9[78]5\\d{2}",
    "zipex": "97500"
  },
  "PN": {
    "require": "ACZ",
    "zip": "PCRN 1ZZ",
    "zipex": "PCRN 1ZZ"
  },
  "PR": {
    "require": "ACZ",
    "zip": "(00[679]\\d{2})(?:[ \\-](\\d{4}))?",
    "zipex": "00930",
    "zip_name_type": "zip"
  },
  "PS": {},
  "PT": {
    "require": "ACZ",
    "zip": "\\d{4}-\\d{3}",
    "zipex": "2725-079,1250-096,1201-950,2860-571,1208-148"
  },
  "PW": {
    "require": "ACSZ",
    "zip": "(969(?:39|40))(?:[ \\-](\\d{4}))?",
    "zipex": "96940",
    "zip_name_type": "zip",
    "state_name_type": "state"
  },
  "PY": {
    "zip": "\\d{4}",
    "zipex": "1536,1538,1209"
  },
  "QA": {},
  "RE": {
    "require": "ACZ",
    "zip": "9[78]4\\d{2}",
    "zipex": "97400"
  },
  "RO": {
    "require": "ACZ",
    "zip": "\\d{6}",
    "zipex": "060274,061357,200716"
  },
  "RS": {
    "zip": "\\d{5,6}",
    "zipex": "106314"
  },
  "RU": {
    "require": "ACSZ",
    "zip": "\\d{6}",
    "zipex": "247112,103375,188300",
    "state_name_type": "oblast"
  },
  "RW": {},
  "SA": {
    "zip": "\\d{5}",
    "zipex": "11564,11187,11142"
  },
  "SB": {},
  "SC": {
    "state_name_type": "island"
  },
  "SD": {
    "zip": "\\d{5}",
    "zipex": "11042,11113"
  },
  "SE": {
    "require": "ACZ",
    "zip": "\\d{3} ?\\d{2}",
    "zipex": "11455,12345,10500"
  },
  "SG": {
    "require": "AZ",
    "zip": "\\d{6}",
    "zipex": "546080,308125,408600"
  },
  "SH": {
    "require": "ACZ",
    "zip": "(?:ASCN|STHL) 1ZZ",
    "zipex": "STHL 1ZZ"
  },
  "SI": {
    "zip": "\\d{4}",
    "zipex": "4000,1001,2500"
  },
  "SJ": {
    "require": "ACZ",
    "zip": "\\d{4}",
    "zipex": "9170"
  },
  "SK": {
    "require": "ACZ",
    "zip": "\\d{3} ?\\d{2}",
    "zipex": "010 01,023 14,972 48,921 01,975 99"
  },
  "SL": {},
  "SM": {
    "require": "AZ",
    "zip": "4789\\d",
    "zipex": "47890,47891,47895,47899"
  },
  "SN": {
    "zip": "\\d{5}",
    "zipex": "12500,46024,16556,10000"
  },
  "SO": {
    "require": "ACS",
    "zip": "[A-Z]{2} ?\\d{5}",
    "zipex": "JH 09010,AD 11010"
  },
  "SR": {},
  "SS": {},
  "ST": {},
  "SV": {
    "require": "ACS",
    "zip": "CP [1-3][1-7][0-2]\\d",
    "zipex": "CP 1101"
  },
  "SX": {},
  "SY": {},
  "SZ": {
    "zip": "[HLMS]\\d{3}",
    "zipex": "H100"
  },
  "TC": {
    "require": "ACZ",
    "zip": "TKCA 1ZZ",
    "zipex": "TKCA 1ZZ"
  },
  "TD": {},
  "TF": {},
  "TG": {},
  "TH": {
    "zip": "\\d{5}",
    "zipex": "10150,10210"
  },
  "TJ": {
    "zip": "\\d{6}",
    "zipex": "735450,734025"
  },
  "TK": {},
  "TL": {},
  "TM": {
    "zip": "\\d{6}",
    "zipex": "744000"
  },
  "TN": {
    "zip": "\\d{4}",
    "zipex": "1002,8129,3100,1030"
  },
  "TO": {},
  "TR": {
    "require": "ACZ",
    "zip": "\\d{5}",
    "zipex": "01960,06101"
  },
  "TT": {},
  "TV": {
    "state_name_type": "island"
  },
  "TW": {
    "require": "ACSZ",
    "zip": "\\d{3}(?:\\d{2,3})?",
    "zipex": "104,106,10603,40867",
    "state_name_type": "county"
  },
  "TZ": {
    "zip": "\\d{4,5}",
    "zipex": "6090,34413"
  },
  "UA": {
    "require": "ACZ",
    "zip": "\\d{5}",
    "zipex": "15432,01055,01001",
    "state_name_type": "oblast"
  },
  "UG": {},
  "UM": {
    "require": "ACS",
    "zip": "96898",
    "zipex": "96898",
    "zip_name_type": "zip",
    "state_name_type": "state"
  },
  "US": {
    "require": "ACSZ",
    "zip": "(\\d{5})(?:[ \\-](\\d{4}))?",
    "zipex": "95014,22162-1010",
    "zip_name_type": "zip",
    "state_name_type": "state"
  },
  "UY": {
    "zip": "\\d{5}",
    "zipex": "11600"
  },
  "UZ": {
    "zip": "\\d{6}",
    "zipex": "702100,700000"
  },
  "VA": {
    "zip": "00120",
    "zipex": "00120"
  },
  "VC": {
    "zip": "VC\\d{4}",
    "zipex": "VC0100,VC0110,VC0400"
  },
  "VE": {
    "require": "ACS",
    "zip": "\\d{4}",
    "zipex": "1010,3001,8011,1020",
    "state_name_type": "state"
  },
  "VG": {
    "require": "A",
    "zip": "VG\\d{4}",
    "zipex": "VG1110,VG1150,VG1160"
  },
  "VI": {
    "require": "ACSZ",
    "zip": "(008(?:(?:[0-4]\\d)|(?:5[01])))(?:[ \\-](\\d{4}))?",
    "zipex": "00802-1222,00850-9802",
    "zip_name_type": "zip",
    "state_name_type": "state"
  },
  "VN": {
    "zip": "\\d{5}\\d?",
    "zipex": "70010,55999"
  },
  "VU": {},
  "WF": {
    "require": "ACZ",
    "zip": "986\\d{2}",
    "zipex": "98600"
  },
  "WS": {},
  "XK": {
    "zip": "[1-7]\\d{4}",
    "zipex": "10000"
  },
  "YE": {},
  "YT": {
    "require": "ACZ",
    "zip": "976\\d{2}",
    "zipex": "97600"
  },
  "ZA": {
    "require": "ACZ",
    "zip": "\\d{4}",
    "zipex": "0083,1451,0001"
  },
  "ZM": {
    "zip": "\\d{5}",
    "zipex": "50100,50101"
  },
  "ZW": {}
};
